import React, {
    useContext,
    useState,
    useEffect,
    useRef
} from 'react';
import { useNavigate } from "react-router";
import { useMutation } from '@tanstack/react-query';

import { getBasketData, refetchBasketData, NotificationContext, handleError } from "../router"
import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import OrderSummary from '../components/order-summary';
import Preferences from './preferences';
import DeliveryOptions from './delivery-options'
import LoadingIndicator from '../components/loading-indicator';
import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/checkout/v2?stylesheet=cog-spektrix.css&resize=true`;

export default function Checkout() {

    const {notification, setNotification} = useContext(NotificationContext);
    let navigate = useNavigate();

    const { data: basketData, isPending } = getBasketData();

    const [hasBasketItems, setHasBasketItems] = useState(false);
    const [page, setPage] = useState(2);
    const [patchBody, setPatchBody] = useState(null);

    const patchBasket = useMutation({
        mutationFn: () => QUERIES.patchBasket(patchBody),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
        },
    })

    useEffect(() => {
        // On load check there are things in the basket and if not redirect the page
        if (!basketData || hasBasketItems) return;

        if (
            basketData.tickets?.length || 
            basketData.donations?.length || 
            basketData.membershipSubscriptions?.length ||
            basketData.ticketSubscriptions?.length ||
            basketData.merchandiseItems?.length
        ) {
            setHasBasketItems(true);
        } else {
            navigate("/basket");
        }
    }, [basketData])

    useEffect(() => {
        if (!patchBody) return;
        patchBasket.mutateAsync();
    }, [patchBody])

    if (!hasBasketItems) return <LoadingIndicator type="page" />

    return (
      <div className='booking-pathway__container booking-pathway__checkout'>
            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Checkout</h1>

                {page == 1 &&
                    <>
                        <Preferences />
                        <div className='booking-pathway__footer'>
                            <button type='button' 
                                    className='btn btn--primary' 
                                    onClick={(e) => setPage((prev) => prev + 1)}>Continue</button>
                        </div>
                    </>
                }

                {page == 2 &&
                    <div className="booking-pathway__checkout-frame">
                        <IFrame url={iframeURL} title="Checkout" hasLoader="true" />
                    </div>
                }
            </div>

            {/* <div className='booking-pathway__footer'>
                <OrderSummary />
                {page == 1 &&
                    <button type='button' 
                            className='btn btn--primary' 
                            onClick={(e) => setPage((prev) => prev + 1)}>Continue</button>
                }
            </div> */}
        </div>
    );
  }